<template>
  <!-- Old bit.dev component -->
  <div class="c-navbar-back">
    <nav
      class="navbar c-navbar-back--bnav"
      role="navigation"
      aria-label="go back"
    >
      <div class="container c-navbar-back--container">
        <div class="column navbar-start c-navbar-back--navbar-start">
          <a
            class="navbar-item c-navbar-back--item"
            v-if="!isLoggedUser && isOpenRouters"
            :href="site_url"
            ><span class="c-navbar-back--svg-icon">
              <base-icon width="100" height="30" name="painel/logo" /> </span
          ></a>

          <a
            v-else-if="isNotOnboardingRouter"
            class="navbar-item c-navbar-back--item"
            @click="back"
          >
            <span class="c-navbar-back--svg-icon">
              <base-icon width="25" height="25" name="painel/arrow-left-icon" />
            </span>
            <span class="c-navbar-back--item__label"> Voltar </span>
          </a>
        </div>
        <div class="column c-navbar-back__title">
          <h2>{{ title }}</h2>
        </div>
        <div
          v-click-outside="closeAdditionalLinks"
          class="column navbar-end c-navbar-back--navbar-end"
        >
          <a
            v-if="additionalLinksMobile.length && isLoggedUser"
            @click="toggleAdditionalLinks"
            class="navbar-item is-hidden-tablet c-navbar-back--item"
          >
            <span class="c-navbar-back--svg-icon">
              <base-icon width="28" height="28" name="painel/bullets-icon" />
            </span>
          </a>
          <transition>
            <ul
              v-if="isAdditionalLinks && additionalLinksMobile.length"
              class="c-navbar-back__nav-mobile"
            >
              <li v-for="(link, index) in additionalLinksMobile" :key="index">
                <router-link :to="link.route">
                  {{ link.title }}
                </router-link>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

const SITE_URL = process.env.VUE_APP_SITE_URL

export default {
  props: {
    title: {
      type: String,
    },

    back: {
      type: Function,
    },

    additionalLinksMobile: {
      type: Array,
      default() {
        return []
      },
    },
  },

  directives: {
    ClickOutside,
  },

  computed: {
    isOpenRouters() {
      return (
        this.$route.name === 'convites' ||
        this.$route.name === 'pix-validacao-email' ||
        this.$route.name === 'pix-validacao-email-path' ||
        this.$route.name === 'pix-brcode-copied'
      )
    },

    isNotOnboardingRouter() {
      return this.$route.name !== 'onboarding'
    },

    isLoggedUser() {
      return this.$store.getters['app/logonTokenBearer']
    },
  },

  data() {
    return {
      isAdditionalLinks: false,
      site_url: SITE_URL,
    }
  },

  methods: {
    closeAdditionalLinks() {
      this.isAdditionalLinks = false
    },

    toggleAdditionalLinks() {
      this.isAdditionalLinks = !this.isAdditionalLinks
    },
  },
}
</script>

<style lang="scss">
$navbar-breakpoint-less-one: $navbar-breakpoint - 1px;
.c-navbar-back {
  font-family: $fontfamily;
  height: 49px;

  @media (min-width: $tablet) {
    height: 60px;
  }

  &--container {
    min-height: 0 !important;
    @media (max-width: $navbar-breakpoint-less-one) {
      position: relative;
      height: 100%;
    }
  }

  &--navbar-start {
    display: flex;
    @media (max-width: $navbar-breakpoint-less-one) {
      float: left;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &--navbar-end {
    position: relative;
    display: flex;
    @media (max-width: $navbar-breakpoint-less-one) {
      float: right;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: $navbar-breakpoint-less-one) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
    h2 {
      color: $gray-5;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      text-align: center;
      @media (min-width: $tablet) {
        font-size: 18px;
      }
    }
  }

  &--bnav {
    @include position(fixed, 0, 0, auto, 0);
    height: 49px;
    min-height: 0;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(64, 73, 81, 0.15);
    z-index: 31;
    @media (min-width: $tablet) {
      height: 60px;
    }
  }

  &--item {
    display: inline-flex;
    align-items: center;
    color: $gray-5;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    top: 1px;
    &:hover,
    &:focus {
      .c-navbar-back--svg-icon {
        fill: $primary;
      }
    }

    &__label {
      display: none;
      @media (min-width: $tablet) {
        display: inline;
      }
    }
  }
  &--svg-icon {
    display: inline-flex;
    @media (min-width: $tablet) {
      margin-right: 12px;
    }
  }

  &__nav-mobile {
    @include position(absolute, 46px, 12px, auto, auto);
    @include app-shadow();
    width: 170px;
    text-align: left;
    z-index: 1;
    border-radius: 4px;
    background-color: $white;

    li > a {
      display: block;
      padding: 0.7em 1.5em;
      color: $gray-7;
      &:hover,
      &:focus {
        background-color: rgba($supportlight, 0.4);
      }
    }
  }

  a:hover,
  a:focus {
    color: $support;
  }
}
</style>
